(() => {
  // app/scripts/product-recommendation-component.js
  var ProductRecommendations = class extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting)
          return;
        observer.unobserve(this);
        fetch(this.dataset.url).then((response) => response.text()).then((text) => {
          this.classList.add("empty-hidden");
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.querySelector(".jsSlideEl")?.load();
          }
          window.klReviewsObject?.renderWidgets?.();
        }).catch((e) => {
          console.error(e);
        });
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "400px 0px 400px 0px" }).observe(this);
    }
  };
  customElements.define("product-recommendations", ProductRecommendations);
})();
